import OverrideText from './OverrideText';

export default OverrideText;
